module.exports = "<span *ngIf=\"(field.touched || field.dirty)\" class=\"cm-validation-message\">\n  {{message}}\n</span>\n"